(function () {
  'use strict';

  var drawer, overlay, closeBtn, bodyEl, footerEl, countEl, subtotalEl;

  /* ── Utilities ──────────────────────────────────────────────── */

  function esc(str) {
    return String(str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function formatMoney(cents) {
    var n = (cents / 100).toFixed(2);
    return '$' + n.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function sizedImg(url, size) {
    if (!url) return '';
    url = url.replace(/^\/\//, 'https://');
    if (/_\d+x\d*\./.test(url)) {
      return url.replace(/_\d+x\d*(\.[^.?]+)/, '_' + size + '$1');
    }
    return url.replace(/(\.[^.?]+)(\?|$)/, '_' + size + '$1$2');
  }

  /* ── Drawer open / close ───────────────────────────────────── */

  function openDrawer() {
    drawer.classList.add('is-open');
    overlay.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-open');
  }

  function closeDrawer() {
    drawer.classList.remove('is-open');
    overlay.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-open');
  }

  /* ── Rendering ─────────────────────────────────────────────── */

  function updateHeaderCount(n) {
    document.querySelectorAll('.cart-count').forEach(function (badge) {
      badge.textContent = n;
      badge.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart, showBadge) {
    /* Count only non-add-on quantities for the visible badge */
    var count = 0;
    (cart.items || []).forEach(function (item) {
      if (!item.properties || item.properties['_is_addon'] !== '1') count += item.quantity;
    });
    if (countEl) countEl.textContent = '(' + count + ')';
    updateHeaderCount(count);

    if (count === 0) {
      bodyEl.innerHTML = [
        '<div class="cart-drawer-empty">',
        '<svg width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="#d0d5dd" stroke-width="1.5" style="display:block;margin:0 auto">',
        '<path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/>',
        '<line x1="3" y1="6" x2="21" y2="6"/>',
        '<path d="M16 10a4 4 0 0 1-8 0"/>',
        '</svg>',
        '<p>Your cart is empty.</p>',
        '<a href="/collections" class="cart-drawer-continue">Continue shopping</a>',
        '</div>'
      ].join('');
      footerEl.style.display = 'none';
      return;
    }

    var html = '';

    if (showBadge) {
      html += [
        '<div class="cart-drawer-added-badge">',
        '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#027D6A" stroke-width="2.5">',
        '<polyline points="20 6 9 17 4 12"/>',
        '</svg>',
        'Added to cart',
        '</div>'
      ].join('');
    }

    /* ── Split items into parents and add-ons by _bundle_key ──── */
    var addonsByKey  = {};
    var parentItems  = [];

    cart.items.forEach(function (item, index) {
      var props     = item.properties || {};
      var bundleKey = props['_bundle_key'] || '';
      var isAddon   = props['_is_addon'] === '1';

      if (isAddon && bundleKey) {
        if (!addonsByKey[bundleKey]) addonsByKey[bundleKey] = [];
        addonsByKey[bundleKey].push({ item: item, line: index + 1 });
      } else {
        parentItems.push({ item: item, line: index + 1, bundleKey: bundleKey });
      }
    });

    html += '<div class="cart-drawer-items">';

    parentItems.forEach(function (entry) {
      var item        = entry.item;
      var img         = sizedImg(item.image, '200x200');
      var imgHtml     = img ? '<img src="' + esc(img) + '" alt="' + esc(item.product_title) + '" loading="lazy">' : '';
      var variantHtml = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<p class="cart-drawer-item-variant">' + esc(item.variant_title) + '</p>'
        : '';

      html += '<div class="cart-drawer-item">';
      html += '<div class="cart-drawer-item-img">' + imgHtml + '</div>';
      html += '<div class="cart-drawer-item-info">';
      html += '<p class="cart-drawer-item-name">' + esc(item.product_title) + '</p>';
      html += variantHtml;
      html += '<div class="cart-drawer-item-row">';
      html += '<span class="cart-drawer-item-qty">Qty: ' + item.quantity + '</span>';
      html += '<span class="cart-drawer-item-price">' + formatMoney(item.final_line_price) + '</span>';
      html += '</div>';
      html += '<button type="button" class="cart-drawer-item-remove"'
            + ' data-variant-id="' + item.variant_id + '"'
            + ' data-bundle-key="' + esc(entry.bundleKey) + '"'
            + ' aria-label="Remove ' + esc(item.product_title) + '">Remove</button>';
      html += '</div>';
      html += '</div>';

      /* ── Nested add-on rows ────────────────────────────────── */
      var addons = entry.bundleKey ? (addonsByKey[entry.bundleKey] || []) : [];
      addons.forEach(function (addonEntry) {
        var addon = addonEntry.item;
        html += '<div class="cart-drawer-addon">';
        html += '<div class="cart-drawer-addon-details">';
        html += '<span class="cart-drawer-addon-name">+ ' + esc(addon.product_title) + '</span>';
        html += '<span class="cart-drawer-addon-qty">× ' + addon.quantity + '</span>';
        html += '<span class="cart-drawer-addon-price">' + formatMoney(addon.final_line_price) + '</span>';
        html += '</div>';
        html += '<button type="button" class="cart-drawer-addon-remove" data-line="' + addonEntry.line + '" aria-label="Remove ' + esc(addon.product_title) + '">Remove</button>';
        html += '</div>';
      });
    });

    html += '</div>';

    bodyEl.innerHTML = html;
    footerEl.style.display = '';
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

    /* ── Wire add-on remove buttons ────────────────────────────── */
    bodyEl.querySelectorAll('.cart-drawer-addon-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var line = parseInt(this.dataset.line, 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
          .then(function (r) { return r.json(); })
          .then(function (updated) { renderCart(updated, false); })
          .catch(function (err) { console.error('[CartDrawer]', err); });
      });
    });

    /* ── Wire parent remove buttons (cascades to add-ons) ─────── */
    bodyEl.querySelectorAll('.cart-drawer-item-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var bundleKey = btn.dataset.bundleKey || '';
        var variantId = parseInt(btn.dataset.variantId, 10);
        showLoading();
        fetchCart()
          .then(function (cart) {
            var linesToRemove = [];
            cart.items.forEach(function (item, idx) {
              var props = item.properties || {};
              var key   = props['_bundle_key'] || '';
              if (item.variant_id === variantId && key === bundleKey) {
                linesToRemove.push(idx + 1);
              }
              if (bundleKey && key === bundleKey && props['_is_addon'] === '1') {
                linesToRemove.push(idx + 1);
              }
            });
            if (!linesToRemove.length) return Promise.resolve(cart);
            var body = cart.items.map(function (item, idx) {
              return 'updates%5B%5D=' + (linesToRemove.indexOf(idx + 1) !== -1 ? 0 : item.quantity);
            }).join('&');
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'X-Requested-With': 'XMLHttpRequest' },
              body: body
            }).then(function (r) { return r.json(); });
          })
          .then(function (cart) { renderCart(cart, false); })
          .catch(function (err) { console.error('[CartDrawer]', err); });
      });
    });
  }

  function showLoading() {
    bodyEl.innerHTML = '<div class="cart-drawer-loading"><div class="cart-drawer-spinner"></div></div>';
    footerEl.style.display = 'none';
  }

  /* ── Cart API calls ──────────────────────────────────────────── */

  function fetchCart() {
    return fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then(function (r) { return r.json(); });
  }

  function addToCart(formData) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    }).then(function (r) {
      if (!r.ok) {
        return r.json().then(function (d) {
          throw new Error(d.description || 'Could not add item to cart.');
        });
      }
      return r.json();
    });
  }

  /* ── Form interception ──────────────────────────────────────────── */

  function handleFormSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();

    var formData  = new FormData(form);
    var variantId = parseInt(formData.get('id') || '0', 10);
    var qty       = parseInt(formData.get('quantity') || '1', 10) || 1;

    showLoading();
    openDrawer();

    fetchCart()
      .then(function (cart) {
        /* Check whether this variant is already a line item */
        var existingLine = 0;
        if (variantId) {
          cart.items.forEach(function (item, idx) {
            if (item.variant_id === variantId) existingLine = idx + 1;
          });
        }

        if (existingLine) {
          /* Already in cart — SET quantity to exactly what was entered */
          return fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ line: existingLine, quantity: qty })
          }).then(function (r) {
            if (!r.ok) return r.json().then(function (d) { throw new Error(d.description || 'Could not update cart.'); });
            return r.json(); /* /cart/change.js returns the full cart */
          });
        }

        /* Not yet in cart — ADD fresh */
        return addToCart(formData).then(function () { return fetchCart(); });
      })
      .then(function (cart) { renderCart(cart, true); })
      .catch(function (err) {
        console.error('[CartDrawer]', err);
        closeDrawer();
        form.submit();
      });
  }

  /* ── Init ──────────────────────────────────────────────────── */

  function init() {
    drawer     = document.getElementById('cart-drawer');
    overlay    = document.getElementById('cart-drawer-overlay');
    closeBtn   = document.getElementById('cart-drawer-close');
    bodyEl     = document.getElementById('cart-drawer-body');
    footerEl   = document.getElementById('cart-drawer-footer');
    countEl    = document.getElementById('cart-drawer-count');
    subtotalEl = document.getElementById('cart-drawer-subtotal');

    if (!drawer) return;

    closeBtn.addEventListener('click', closeDrawer);
    overlay.addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    document.body.addEventListener('submit', handleFormSubmit);

    window.CartDrawer = {
      open: function () {
        showLoading();
        openDrawer();
        fetchCart().then(function (cart) { renderCart(cart, false); });
      },
      close: closeDrawer,
      refresh: function () {
        fetchCart().then(function (cart) { renderCart(cart, false); });
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();